import { Link, useLocation } from 'react-router-dom';
import {
  LayoutDashboard,
  Users,
  Stethoscope,
  Calendar,
  ClipboardList,
  Clock,
  Gift,
  CreditCard,
  BarChart3,
  Settings,
  Bell,
  BellRing,
  FileText,
  X,
  PawPrint,
  Percent,
  Package,
  Receipt,
} from 'lucide-react';
import { useEffect } from 'react';
import logoVetSuite from '../assets/logo_vet_suite_v2.png';

const menuItems = [
  { section: 'Operacion' },
  { label: 'Dashboard', icon: LayoutDashboard, href: '/dashboard' },
  { label: 'Atención', icon: ClipboardList, href: '/atencion' },
  { label: 'Agenda', icon: Calendar, href: '/agenda' },
  { label: 'Disponibilidades', icon: Clock, href: '/disponibilidades' },
  { label: 'Clientes', icon: Users, href: '/clientes' },
  { label: 'Mascotas', icon: PawPrint, href: '/mascotas' },
  { label: 'Posts inicio', icon: FileText, href: '/posts' },
  { section: 'Comercial' },
  { label: 'Fidelizacion', icon: Gift, href: '/fidelizacion' },
  { label: 'Descuentos', icon: Percent, href: '/descuentos' },
  { label: 'Cobros Directos', icon: Receipt, href: '/cobros-directos' },
  { label: 'Cobranza', icon: CreditCard, href: '/pagos' },
  { label: 'Push a clientes', icon: BellRing, href: '/push-clientes' },
  { section: 'Tienda' },
  { label: 'Productos',icon: Gift, href: '/tienda/productos' },
  { label: 'Pedidos',icon: Gift, href: '/tienda/pedidos' },
  { label: 'Compras y Bodega', icon: Package, href: '/inventario' },
  { section: 'Gestion' },
  /*{ label: 'Usuarios', icon: Users, href: '/usuarios' },*/
  { label: 'Profesionales', icon: Stethoscope, href: '/profesionales' },
  { label: 'Reportes', icon: BarChart3, href: '/reportes' },
  { label: 'Notificaciones', icon: Bell, href: '/notificaciones' },
  /*{ label: 'Configuración', icon: Settings, href: '/configuracion' },*/
];

const Sidebar = ({ isOpen, onClose }) => {
  const location = useLocation();

  useEffect(() => {
    onClose();
  }, [location, onClose]);

  const isActive = (href) => location.pathname === href || location.pathname.startsWith(href + '/');

  return (
    <>
      {/* Overlay mobile */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-30 md:hidden"
          onClick={onClose}
        />
      )}

      {/* Sidebar */}
      <aside
        className={`fixed left-0 top-0 z-40 h-screen w-72 transform bg-gray-950 text-white transition-transform duration-300 md:relative md:translate-x-0 ${
          isOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
      >
        <div className="flex items-center justify-between border-b border-gray-800 p-4">
          <div className="flex items-center gap-3">
            <div className="flex h-16 w-16 items-center justify-center rounded-md bg-white">
              <img src={logoVetSuite} alt="VetSuite" className="max-h-10 w-full object-contain" />
            </div>
            <div>
              <p className="text-xs text-gray-400">Panel de Administración</p>
              <p className="text-xs text-gray-400">Tu Veterinaria</p>
            </div>
          </div>
          <button onClick={onClose} className="p-2 hover:bg-gray-800 rounded-lg md:hidden">
            <X className="w-5 h-5" />
          </button>
        </div>

        <nav className="h-[calc(100vh-80px)] space-y-1 overflow-y-auto p-4">
          {menuItems.map((item) => (
            <div key={item.label || item.section}>
              {item.section && (
                <p className="px-3 pb-1 pt-4 text-xs font-semibold uppercase tracking-wide text-gray-500 first:pt-0">
                  {item.section}
                </p>
              )}
              {!item.section && item.submenu ? (
                <details className="group" open={item.submenu.some((subitem) => isActive(subitem.href))}>
                  <summary className="flex cursor-pointer items-center gap-3 rounded-md px-3 py-2 text-gray-300 transition hover:bg-gray-800 hover:text-white">
                    <item.icon className="w-5 h-5" />
                    <span>{item.label}</span>
                  </summary>
                  <div className="pl-8 space-y-1 mt-2">
                    {item.submenu.map((subitem) => (
                      <Link
                        key={subitem.href}
                        to={subitem.href}
                        className={`block px-4 py-2 rounded-lg transition text-sm ${
                          isActive(subitem.href)
                            ? 'bg-blue-600 text-white'
                            : 'text-gray-400 hover:bg-gray-800'
                        }`}
                      >
                        {subitem.label}
                      </Link>
                    ))}
                  </div>
                </details>
              ) : !item.section ? (
                <Link
                  to={item.href}
                  className={`flex items-center gap-3 px-4 py-2 rounded-lg transition ${
                    isActive(item.href)
                      ? 'bg-blue-600 text-white'
                      : 'text-gray-400 hover:bg-gray-800'
                  }`}
                >
                  <item.icon className="w-5 h-5" />
                  <span>{item.label}</span>
                </Link>
              ) : null}
            </div>
          ))}
        </nav>
      </aside>
    </>
  );
};

export default Sidebar;
